import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface StepFourProps {
  message: string;
}

const StepFour: React.FC<StepFourProps> = ({ message }) => {
  return (
    <Box className="vp-container" sx={{ textAlign: 'center', maxWidth: '900px', margin: 'auto' }}>
      <Box sx={{ lineHeight: '20px' }}>
        <Typography component="strong" fontWeight={600} mb={3} display="block">
          {message}
        </Typography>

        <Box display="flex" justifyContent="center" gap={2}>
          <Button
            className="blueButtonOutline submit-button-white" sx={{ mt: 3 }}
            onClick={() => (window.location.href = '/lbpcustomer/gallery?searchWindows=true')} >
            Back to Windows
          </Button>
          <Button
            className="blueButtonOutline submit-button-blue" sx={{ mt: 3 }}
            onClick={() => (window.location.href = '/lbpcustomer')}>
            Return to LansingNow
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default StepFour;
